export const isMobileView = () => {
  return window.innerWidth <= 768;
};

export const isTabletView = () => {
  return window.innerWidth <= 992;
};
